export default __webpack_public_path__ + "img/d5db751abd9ce350c15be7110697cf8a.svg";